import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints';

export interface ActivityReportRequest {
  fromDate: string;
  toDate: string;
  center?: string | null;
  activity?: string | null;
  /** booked = not yet staff-delivered; delivered = staff confirmed */
  mode?: 'booked' | 'delivered' | null;
}

export interface ActivityReportRow {
  userName: string;
  activity: string;
  type: string;
  providedBy: string;
  center: string;
  participatedAt?: string;
  isDelivered?: boolean;
}

export interface ActivityReportResponse {
  statusCode: number;
  message: string;
  fromDate: string;
  toDate: string;
  rows: ActivityReportRow[];
}

@Injectable({
  providedIn: 'root',
})
export class ActivityReportService {
  private readonly apiService = inject(ApiService);

  getReport(request: ActivityReportRequest): Observable<ActivityReportResponse> {
    return this.apiService.post<ActivityReportResponse>(
      API_ENDPOINTS.REPORTS.ACTIVITY,
      request,
    );
  }
}
